/*
  *****WARNING*****

  User agent sniffing is an anti-pattern, you may want to explore other approaches
  before using code in this lib
  https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent

  *****WARNING*****
*/

const MobileDetection = {
  hasUserAgent() {
    if (typeof navigator !== 'undefined') {
      return navigator.userAgent || ' ';
    }
    return false;
  },

  Android() {
    return this.hasUserAgent()
      && navigator.userAgent.match(/Android/i);
  },

  BlackBerry() {
    return this.hasUserAgent()
      && navigator.userAgent.match(/BlackBerry/i);
  },

  iOS() {
    // IE 11 has `iphone` in their userAgent for Windows Phone 8.1, this extra check
    // helps guard against that
    return this.hasUserAgent()
      && navigator.userAgent.match(/iPhone|iPad|iPod/i)
      && !window.MSStream;
  },

  Opera() {
    return this.hasUserAgent()
      && navigator.userAgent.match(/Opera Mini/i);
  },

  Windows() {
    return this.hasUserAgent()
      && navigator.userAgent.match(/IEMobile/i);
  },

  any() {
    return (
      MobileDetection.Android()
      || MobileDetection.BlackBerry()
      || MobileDetection.iOS()
      || MobileDetection.Opera()
      || MobileDetection.Windows()
    );
  },
};

export default MobileDetection;
